<div class="sb-outer" [style]="{'--zsb-right': (snackBarData?.horizontalPosition === 'end' ||snackBarData?.horizontalPosition === 'right') ? '30px' : '',
          '--zsb-left': (snackBarData?.horizontalPosition === 'start' || snackBarData?.horizontalPosition === 'left') ? '30px' : '',
          '--zsb-bottom': !(snackBarData?.verticalPosition && snackBarData?.horizontalPosition)?'30px':(snackBarData?.verticalPosition === 'bottom') ? '30px' : '',
          '--zsb-top':(snackBarData?.verticalPosition === 'top') ? '30px' : ''}">
  <div class="sb-inner"
    [ngClass]="{'sb-success-inner':snackBarData?.actionType==='success', 'sb-info-inner':snackBarData?.actionType==='info','sb-warning-inner':snackBarData?.actionType==='warning','sb-error-inner':snackBarData?.actionType==='error','sb-default-inner':snackBarData?.actionType==='default'}">
    <div class="sb-mess-pre-icon">
      @if(snackBarData?.prefixIcon && snackBarData?.actionType!=='default'){
      <div class="sb-pre-icon ">
        <zen-icon
          [iconName]="snackBarData?.actionType==='success'?'check_circle':snackBarData?.actionType==='warning'?'report_problem':snackBarData?.actionType==='info' ? 'info':'error'"
          class="sb-zen-icon sb-zen-icon-weight" [type]="'fill'">
        </zen-icon>
      </div>
      }
      <div class="sb-message">{{snackBarData?.message }}</div>
    </div>
    <div class="sb-button-icon">
      @if(snackBarData?.buttonType === 'icon' && snackBarData?.buttonText){
      <div class="cursor">
        <zen-icon class="sb-zen-icon"
          [iconName]="snackBarData && snackBarData.buttonText ? snackBarData.buttonText:'close'"
          (click)="closeSnackbar()">
        </zen-icon>
      </div>
      }
      @else if (snackBarData?.buttonType === 'button') {
      <div class="cursor">
        <button (click)="closeSnackbar()" class="sb-button">
          {{snackBarData?.buttonText}}</button>
      </div>
      }
      @else if( snackBarData?.durationTime && !snackBarData?.buttonType) {
      <span></span>
      }
      @else{
      <div class="cursor">
        <zen-icon class="sb-zen-icon sb-zen-icon-size" iconName="close" (click)="closeSnackbar()"></zen-icon>
      </div>
      }
    </div>
  </div>
</div>